import type { FlowCreationDrawer as FlowCreationDrawerProps } from '../types';
import { FlowCreationChatView } from './FlowCreationChatView';
import { FlowCreationEmptyView } from './FlowCreationEmptyView';

export const FlowCreationDrawerBody = (props: FlowCreationDrawerProps) => {
  const { data } = props;

  if (data.view === 'empty') {
    return <FlowCreationEmptyView />;
  }

  return <FlowCreationChatView {...props} />;
};
